import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUserRequest } from '~/store/modules/user/actions';
import { Mobile, Desktop } from './responsive';
import { Responsive } from '~/components';

export default function Header() {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    if (!Object.keys(user).length) dispatch(getUserRequest());
  }, [dispatch, user]);

  const { t } = useTranslation();

  const renderProps = {
    user,
    dispatch,
  };

  return (
    <Responsive
      xs={<Mobile {...renderProps} />}
      sm={<Mobile title={t('appName')} {...renderProps} />}
      lg={<Desktop {...renderProps} />}
    />
  );
}
